
import { MessagesAndInstructionsLang } from "../../resources/MessagesAndInstructionsLang";
import { ErrorCodes } from "../../dtos/KioskDtos.dtos";

export const getErrorMessages = (messages: MessagesAndInstructionsLang, errorCode: ErrorCodes): string => {
    switch (errorCode) {
        case ErrorCodes.PostalCodeCheckUnsuccessful:
            return messages.PostalCodeCheckUnsuccessfulMessage;

        case ErrorCodes.HealthCardExpired:
            return messages.HealthCardExpiredMessage;

        case ErrorCodes.UnableToUpdatePatientInformation:
            return messages.UnableToUpdatePatientInformationMessage;

        case ErrorCodes.UnableToUpdateAppointmentStatus:
            return messages.UnableToUpdateAppointmentStatusMessage;

        case ErrorCodes.NoAppointmentsFound:
            return messages.NoAppointmentsFoundMessage;

        case ErrorCodes.NoAvailableAppointments:
            return messages.NoAvailableAppointmentsMessage;

        case ErrorCodes.NoPatientsFound:
            return messages.NoPatientsFoundMessage;

        case ErrorCodes.MultiplePatientsFound:
            return messages.MultiplePatientsFoundMessage;

        case ErrorCodes.NoAddressesFound:
            return messages.NoAddressesFoundMessage;

        case ErrorCodes.NotAbleToBookNewAppointment:
            return messages.NotAbleToBookNewAppointmentMessage;

        case ErrorCodes.AppointmentAlreadyExists:
            return messages.AppointmentAlreadyExistForNewBookingMessage;

        case ErrorCodes.BarcodeUnreadable:
            return messages.BarcodeUnreadableErrorMessage;
        default:
            return "";
    }
}

export const getRedirectPatientMessage = (messages: MessagesAndInstructionsLang, errorCode: ErrorCodes): string => {
    switch (errorCode) {
        case ErrorCodes.HealthCardExpired:
            return messages.PleaseSeeReceptionToUpdateInformationMessage;
        default:
            return messages.PleaseSeeReceptionMessage;
    }
}


// WEBPACK FOOTER //
// ./src/services/Language/GetErrorMessages.ts